import { AuthService } from '@anecdotes/auth-core';
import { FeatureFlagsService } from '@anecdotes/feature-flags';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AppRoutes, AppTrustCenterPageRouteSegments } from '@anecdotes/configuration-data-access';

@Injectable()
export class DefaultRedirectionGuard  {
  constructor(private featureFlagsService: FeatureFlagsService, private router: Router, private authService: AuthService) {}

  async canActivateChild(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (state.url !== '/') {
      return true;
    }

    if (!await this.authService.isAuthenticatedAsync()) {
      return true;
    }

    if (await this.featureFlagsService.IsEnabledAsync('@frameworks-page')) {
      return this.router.createUrlTree([AppRoutes.Frameworks]);
    }

    if (await this.featureFlagsService.IsEnabledAsync('@plugins-page')) {
      return this.router.createUrlTree([AppRoutes.Plugins]);
    }

    if (await this.featureFlagsService.IsEnabledAsync('@trust-center')) {
      return this.router.createUrlTree([AppRoutes.TrustCenter, AppTrustCenterPageRouteSegments.Access]);
    }

    if (await this.featureFlagsService.IsEnabledAsync('@auditors-portal')) {
      return this.router.createUrlTree([AppRoutes.AuditorsPortal]);
    }

    return this.router.createUrlTree([AppRoutes.MyAnecdotes]);
  }
}
